import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import ShareWarningForm from 'pages/explorer/warnings/share-warning-form'
import type { ChannelShareFormProps } from '../../types'
import PublicLink from './PublicLink'

const PublicLinkTab = (props: ChannelShareFormProps): React.ReactNode => {
  const params = useParams<{ channelId: string }>()
  const [showTerritories, setShowTerritories] = useState(
    props.user.business.private_metadata.territories_enabled &&
      !props.publicUrl,
  )
  const handleSubmit = useCallback(() => {
    setShowTerritories(false)
  }, [])
  return showTerritories ? (
    <ShareWarningForm
      params={params as { channelId: string }}
      onSubmit={handleSubmit}
    />
  ) : (
    <PublicLink {...props} />
  )
}

export default PublicLinkTab
